import { useState, useCallback, useRef } from 'react';
export const useScreenShareToggle = (room, id, onError) => {
    const [isSharing, setIsSharing] = useState(false);
    const stopScreenShareRef = useRef(null);
    const shareScreen = useCallback(() => {
        if (!room)
            return;
        window.navigator.mediaDevices
            .getDisplayMedia({
            audio: true,
            video: {
                frameRate: { ideal: 10 },
                width: { max: 1920 },
                aspectRatio: { ideal: 16 / 9 }
            }
        })
            .then((stream) => {
            const tracks = stream.getTracks();
            const screenTrack = tracks.find((track) => track.kind === 'video');
            const audioTrack = tracks.find((track) => track.kind === 'audio');
            if (!screenTrack) {
                onError(new Error('cannot share screen'));
                return;
            }
            Promise.all([
                room.localParticipant
                    .publishTrack(screenTrack, {
                    name: `screen-${id}-${Date.now()}`,
                    priority: 'low'
                })
                    .catch(onError),
                audioTrack
                    ? room.localParticipant.publishTrack(audioTrack, {
                        name: `mic-${id}-${Date.now()}`
                    })
                    : Promise.resolve()
            ])
                .then((trackPublications) => {
                stopScreenShareRef.current = () => {
                    room.localParticipant.unpublishTrack(screenTrack);
                    if (audioTrack)
                        room.localParticipant.unpublishTrack(audioTrack);
                    // TODO: remove this if the SDK is updated to emit this event
                    trackPublications.forEach((trackPublication) => {
                        if (trackPublication)
                            room.localParticipant.emit('trackUnpublished', trackPublication);
                    });
                    screenTrack.stop();
                    if (audioTrack)
                        audioTrack.stop();
                    setIsSharing(false);
                };
                screenTrack.onended = stopScreenShareRef.current;
                setIsSharing(true);
            })
                .catch((err) => {
                console.error(err);
                onError(err);
            });
        })
            .catch((error) => {
            // Don't display an error if the user closes the screen share dialog
            if (error.message === 'Permission denied by system' ||
                (error.name !== 'AbortError' && error.name !== 'NotAllowedError')) {
                console.error(error);
                onError(error);
            }
        });
    }, [room, onError, id]);
    const toggleScreenShare = useCallback(() => {
        if (room) {
            !isSharing ? shareScreen() : stopScreenShareRef.current();
        }
    }, [isSharing, shareScreen, room]);
    return [isSharing, toggleScreenShare];
};
//# sourceMappingURL=useScreenShareToggle.js.map